module.exports = __webpack_public_path__ + "static/media/inbox.a211f620.svg";